<script lang="ts">
    import { location, navigation, sites, temperature, banner, serviceNavigation} from "./lib/stores"
    import Header from "./lib/components/header/Header.svelte"
    import Footer from "./lib/components/Footer.svelte"
    import { Route, Router } from "svelte-routing"
    import HomePage from "./routes/HomePage.svelte"
    import { loadNavigation } from "./lib/functions/loadNavigation"
    import { loadBanner } from "./lib/functions/loadBanner"
    import { loadSites } from "./lib/functions/loadSites"
    import { loadTemperature } from "./lib/functions/loadTemperature"
    import Site from "./routes/Site.svelte"
    import Banner from "./lib/components/pagebuilder/banner.svelte"
    import NotFound from "./routes/NotFound.svelte"
    import insta from "../media/instagram.svg"
    export let url = ""
  
    if (url) {
        // ssr
        let l = url.split("?")
        $location = {
            path: l[0],
            search: l.length > 1 ? l[1] : "",
            hash: "",
            categoryPath: l[0].replace(/\/[^_\/]+_[^\/]+$/, ""),
            push: false,
            pop: false,
        }
    }

    async function getNavigation() {
        let nav: Navigation = await loadNavigation()
        $navigation = nav[0]
        $serviceNavigation = nav[1]
    }
    async function getBanner() {
        let banner: Banner[] = await loadBanner()
        console.log(banner)
        $banner = banner
    }
    async function getSites() {
        let sitesArray: Site[] = await loadSites()
        let sites: Sites = {}

        sitesArray.forEach((e) => {
            sites[e.id] = e
        })
        $sites = sites
    }

    async function getTemperature() {
        let temperature = await loadTemperature()
        console.log(temperature)
        $temperature = temperature.temperature.toFixed(2)
    }
    getNavigation()
    getSites()
    getBanner()
    getTemperature()

    // scroll to top on new site
    location.subscribe((l) => {
        if (l.push) scrollToTop()
    })
</script>

<main class="">
    <Header />
    <div class="content-container" id="siteContainer">
        <Router url="{url}">
            <Route path="/">
                <HomePage />
            </Route>
            <Route path="/*path" let:params>
                <Site path="{params.path}" />
            </Route>
            <Route>
                <NotFound />
            </Route>
        </Router>
        <Footer />
    </div>
    <button class="arrow-up" on:click="{() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}"
        ><img src="media/arrow-up.svg" alt="arrow" /></button
    >
    <Banner />
    <div class="socialMedia">
        <a target="_blank" href="https://www.instagram.com/wasserski_erfurt/"
            ><img src="media/instagram.svg" alt="insta" /></a
        >
        <a target="_blank" href="https://www.facebook.com/wasserskierfurt/"><img src="media/facebook.svg" alt="fb" /></a
        >
    </div>
</main>

<style lang="less">
    @import "./lib/assets/css/main.less";
    @import "./lib/assets/css/fonts.less";
    @font-face {
        font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
        font-family: "Roboto Condensed";
        font-style: normal;
        font-weight: 400;
        src: url("./lib/assets/fonts/roboto-condensed-v25-latin-regular.eot");
        src: url("./lib/assets/fonts/roboto-condensed-v25-latin-regular.eot") format("embedded-opentype"),
            url("./lib/assets/fonts/roboto-condensed-v25-latin-regular.woff2") format("woff2"),
            url("./lib/assets/fonts/roboto-condensed-v25-latin-regular.woff") format("woff"),
            url("./lib/assets/fonts/roboto-condensed-v25-latin-regular.ttf") format("truetype"),
            url("./lib/assets/fonts/roboto-condensed-v25-latin-regular.svg") format("svg");
    }

    .socialMedia {
        display: none;
    }

    @media @tablet {
        .socialMedia {
            position: fixed;
            top: 50%;
            transform: translate(60%, -50%);
            right: 2.25vw;
            display: flex;
            flex-direction: column;
            z-index: 1000;
        }
    }

    main {
        font-family: "Roboto Condensed", sans-serif;
        overflow: hidden;
        max-width: @body-maxwidth;
        width: 100vw;
        overflow-x: hidden;
        display: flex;
        align-items: center;
        flex-direction: column;
        color: @normal-font-color;
        .arrow-up {
            position: fixed;
            display: flex;
            align-items: center;
            justify-content: center;
            bottom: 10px;
            right: 10px;
            height: 2rem;
            width: 2rem;
            border-radius: 50%;
            z-index: 1000;
            background-color: @link-font-color;
            img {
                transform-origin: center;
            }
        }
        .content-container {
            display: flex;
            z-index: 10;
            flex-direction: column;
            width: 100%;
            align-items: center;
            overflow: hidden;
            justify-content: center;
        }
    }
    @media (min-width: 1800px) {
        .socialMedia {
            right: calc(50vw - 900px);
            transform: translate(-50%, -50%);
        }
        .arrow-up {
            right: calc(50vw - 900px) !important;
        }
    }
</style>
